import { useId } from 'react';
import type { CustomFieldProps } from './types';
import { DateTimePicker } from '../../dynamic-field/components/date-field/date-time-picker';
import { parseDateTime } from '@internationalized/date';
import { CustomFieldLabel } from './custom-field-label';
import { CustomFieldHelperText } from './custom-field-helper-text';
import { DateTime } from 'luxon';

export function CustomDateTimeField({
  title,
  onValueChange,
  value,
  disabled,
  required,
  description,
  error,
}: CustomFieldProps) {
  const id = useId();
  const format = value
    ? DateTime.fromFormat(value, 'yyyy/MM/dd HH:mm:ssZZ').toISO({
        includeOffset: false,
      })
    : null;
  const parsedValue = format ? parseDateTime(format) : null;
  return (
    <div className='w-full not-first:*:mt-2'>
      <CustomFieldLabel required={required} htmlFor={id}>
        {title}
      </CustomFieldLabel>
      <DateTimePicker
        granularity='minute'
        isRequired={required}
        value={parsedValue}
        isDisabled={disabled}
        onChange={(value) => {
          const backendParsedValue = value
            ? DateTime.fromISO(value.toString()).toFormat(
                'yyyy/MM/dd HH:mm:ssZZ'
              )
            : '';
          onValueChange?.(backendParsedValue);
        }}
      />
      <CustomFieldHelperText error={error} description={description} />
    </div>
  );
}
